import { useRootStore } from './useRootStore';

export function useEnterStore() {
  const { enterStore } = useRootStore();
  return enterStore;
}
